module.exports = __webpack_public_path__ + "static/media/009.e215ebff.svg";